module.exports = __webpack_public_path__ + "img/customer-service-bg.ed35ef2b.png";